import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  FaEnvelope,
  FaBullhorn,
  FaSignOutAlt,
  FaQuestionCircle,
  FaShieldAlt,
  FaBriefcase,
  FaLightbulb,
  FaRupeeSign,
  FaBuilding
} from "react-icons/fa";
import "./ProfileSidebar.css";
import { logout } from "../utils/auth";
import GetLeadsModal from "./GetLeadsModal";
import Helpmodel from "../main/dashboard/HelpModal";
const ProfileSidebar = ({ open, onClose, company, profileImage }) => {
      const [openLeads, setOpenLeads] = useState(false);
        const [openHelp, setOpenHelp] = useState(false);

  if (!open) return null;

  return (
    <div className="profile-overlay" onClick={onClose}>
      <aside
        className="profile-sidebar"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close */}
        <button className="profile-close" onClick={onClose}>×</button>

        {/* Profile */}
        <div className="profile-top">
          <img src={profileImage} alt="Profile" />
          <h4>{company?.company_name}</h4>
        </div>

        {/* Menu */}
        <div className="profile-menu">


          <Link to="/agency" className="jd-link agency-highlight">
  <FaBuilding />
  <span>Agency</span>
</Link>


          <div
                        className="profile-item"
                        onClick={() => setOpenLeads(true)}
                        style={{ cursor: "pointer" }}
                      >
                        <FaEnvelope className="menu-icon" />
                        <span>Leads</span>
                      </div>
                      <GetLeadsModal
                                    open={openLeads}
                                    onClose={() => setOpenLeads(false)}
                                  />

          <Link to="/business-listing" className="profile-item">
            <FaBullhorn /> List your Business
            <span className="free-badge">Free</span>
          </Link>
          <Link to="/pricing" className="profile-item">
            <FaRupeeSign /> Plans
          </Link>

          <div className="profile-item">
            <FaBullhorn /> Advertise
          </div>
                    <Link to="/Customerservice" className="profile-item">
            <FaQuestionCircle /> Customer Service
          </Link>
          

          <div
              className="profile-item"
              onClick={() => setOpenHelp(true)}
              style={{ cursor: "pointer" }}
            >
            <FaQuestionCircle /> Help
          </div>
          <Helpmodel isOpen={openHelp} onClose={() => setOpenHelp(false)} />

          <div className="profile-item">
            <FaBriefcase /> Settings
          </div>
          
          <Link to="/privacypolicy" className="profile-item">
            <FaShieldAlt /> Privacy Policy
          </Link>

          <div className="profile-item">
            <FaLightbulb /> What’s New
          </div>

          {/* Logout */}
          <button className="profile-logout" onClick={logout}>
            <FaSignOutAlt /> Logout
          </button>
        </div>
      </aside>
    </div>
  );
};

ProfileSidebar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  company: PropTypes.object,
  profileImage: PropTypes.string.isRequired,
};

export default ProfileSidebar;
